import { css } from "styled-components"

export const FocusNextStyle = css`
  animation: focusNext 1.2s linear infinite;
  background: #fff3d8;
  border: 1px solid #ff6010;
  border-radius: 5px;
  @keyframes focusNext {
    0% {
      border-radius: 5px;
      box-shadow: 0px 0px 0px 0px rgba(255, 96, 16, 1);
    }
    100% {
      border-radius: 5px;
      box-shadow: 0px 0px 0px 5px rgba(255, 96, 16, 0.6);
    }
  }
`
